import { CodeOutputBlock, Text } from '@/ui';
import { settingsCopyTextSx } from '@/ui/composites/settingsPageTypographySx';
import { TextField } from '@/ui/primitives/TextField';

type ProjectWebhookSnippetSectionProps = {
  tagsInput: string;
  onTagsInputChange: (value: string) => void;
  snippet: string;
  onCopySnippet: () => void;
  disabled: boolean;
};

export const ProjectWebhookSnippetSection = ({
  tagsInput,
  onTagsInputChange,
  snippet,
  onCopySnippet,
  disabled,
}: ProjectWebhookSnippetSectionProps): JSX.Element => {
  return (
    <>
      <TextField
        label="Webhook Tags (Comma-Separated)"
        fieldStyle="settings"
        value={tagsInput}
        placeholder="smoke, nightly"
        helperText={
          <Text role="body" component="span" color="textSecondary" sx={settingsCopyTextSx}>
            Tags are attached to the webhook key and inferred on incoming webhook events.
          </Text>
        }
        disabled={disabled}
        onChange={(event) => {
          onTagsInputChange(event.target.value);
        }}
      />
      <CodeOutputBlock
        value={snippet}
        onCopy={onCopySnippet}
        copyAriaLabel="Copy webhook snippet"
        reserveCopySpace={false}
      />
    </>
  );
};
